/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectGsvPerMonthPerCategoryResponse
 */
export interface ProjectGsvPerMonthPerCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectGsvPerMonthPerCategoryResponse
     */
    monthAndYear: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectGsvPerMonthPerCategoryResponse
     */
    freelancerCategory: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectGsvPerMonthPerCategoryResponse
     */
    gsv: number;
}

/**
 * Check if a given object implements the ProjectGsvPerMonthPerCategoryResponse interface.
 */
export function instanceOfProjectGsvPerMonthPerCategoryResponse(value: object): value is ProjectGsvPerMonthPerCategoryResponse {
    if (!('monthAndYear' in value) || value['monthAndYear'] === undefined) return false;
    if (!('freelancerCategory' in value) || value['freelancerCategory'] === undefined) return false;
    if (!('gsv' in value) || value['gsv'] === undefined) return false;
    return true;
}

export function ProjectGsvPerMonthPerCategoryResponseFromJSON(json: any): ProjectGsvPerMonthPerCategoryResponse {
    return ProjectGsvPerMonthPerCategoryResponseFromJSONTyped(json, false);
}

export function ProjectGsvPerMonthPerCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectGsvPerMonthPerCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthAndYear': json['monthAndYear'],
        'freelancerCategory': json['freelancerCategory'],
        'gsv': json['gsv'],
    };
}

export function ProjectGsvPerMonthPerCategoryResponseToJSON(value?: ProjectGsvPerMonthPerCategoryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'monthAndYear': value['monthAndYear'],
        'freelancerCategory': value['freelancerCategory'],
        'gsv': value['gsv'],
    };
}

